import { RenterDto } from '@tallo/renter';

import { ShowingRequestStatus } from '../interfaces/showing-request-status.enum';
import { ShowingDto } from '../interfaces/showing.interface';

export function getAcceptedRenters(showing: ShowingDto): RenterDto[] {
  return showing.showingRequests
    .filter(({ status }) => status === ShowingRequestStatus.ACCEPTED)
    .map(({ renter }) => renter);
}
